/**
 * Rustige plaatshouder zolang data laadt. Pulseert alleen als de bezoeker
 * geen "minder beweging" heeft ingesteld; altijd verborgen voor schermlezers
 * (de laadstatus wordt apart gemeld met role="status").
 */
export function Skeleton({
  className = ''
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`block bg-line/60 motion-safe:animate-pulse ${className}`} data-id="element-9209" data-mp="2af3po7sa4fd0" />;
}